import { EventActionType } from './event-action-type';

export interface SetEventTagsAction {
  eventKey: string;
  tags: string;
  type: EventActionType.SetEventTags;
}

export const setEventTags = (
  eventKey: string,
  tags: string,
): SetEventTagsAction => ({
  eventKey,
  tags,
  type: EventActionType.SetEventTags,
});
